module.exports = __webpack_public_path__ + "img/about-bio-3@2x.b6d93463.jpg";